/**
 * 规则缺陷 — every finding on the draft, worst first (utils/issueList.ts).
 *
 * A finding about a single eligibility rule selects that rule's label; anything else selects
 * the question.
 */
import { Box, Link, SpaceBetween, StatusIndicator } from '@amzn/awsui-components-react';

import { type IssueRow } from '../../utils/issueList';
import './SidePanel.css';

export interface IssuesPanelProps {
  rows: IssueRow[];
  onSelectNode: (id: string) => void;
}

const labelOf = (r: IssueRow) =>
  r.severity === 'error' ? '缺陷' : r.severity === 'warning' ? '可疑' : r.needsConfirm ? '需确认' : '提示';

export default function IssuesPanel({ rows, onSelectNode }: IssuesPanelProps) {
  if (rows.length === 0) return <Box color="text-status-inactive">没有发现问题</Box>;
  const count = (label: string) => rows.filter((r) => labelOf(r) === label).length;
  return (
    <SpaceBetween size="s">
      <Box variant="small" color="text-body-secondary">
        缺陷 {count('缺陷')} · 可疑 {count('可疑')} · 需确认 {count('需确认')} · 提示 {count('提示')}。只有缺陷和可疑计入角标、标在画布上；需确认 = 行为属实，是否算错由业务定。随草稿实时重算。
      </Box>
      {rows.map((r) => {
        const target =
          r.nodeId && r.rule?.kind === 'program' ? `${r.nodeId}::rule::${r.rule.index}` : r.nodeId;
        return (
          <div key={r.id} className="cpa-issue">
            <div className="cpa-sim__qh">
              <StatusIndicator type={r.needsConfirm ? 'pending' : r.severity}>{labelOf(r)}</StatusIndicator>
              {target && (
                <Link onFollow={() => onSelectNode(target)}>
                  {r.nodeId}
                  {r.rule ? ` · ${r.rule.kind === 'program' ? '资格' : r.rule.kind === 'nav' ? '导航' : '自动作答'} #${r.rule.index + 1}` : ''}
                </Link>
              )}
              <span className="cpa-sim__count">{r.code}</span>
            </div>
            <div className="cpa-sim__qt">{r.message}</div>
            {r.expression && <code className="cpa-issue__expr">{r.expression}</code>}
          </div>
        );
      })}
    </SpaceBetween>
  );
}
